<template>
  <div class="overview-panel border rounded p-3 h-100">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h3 class="h6 mb-0">Budget Overview</h3>
      <small class="text-muted">{{ selectedSnapshot?.alias }}</small>
    </div>

    <div v-if="overviewRows.length === 0" class="text-muted small">
      This snapshot has no categories.
    </div>

    <div v-for="row in overviewRows" :key="row.categoryUid" class="mb-2">
      <div class="d-flex justify-content-between align-items-center gap-2">
        <strong class="small text-truncate">{{ row.name }}</strong>
        <div class="d-flex align-items-center gap-1">
          <div
            class="spent-chip position-relative overflow-hidden rounded border"
          >
            <div
              class="spent-chip-progress"
              :class="{
                'bg-success-subtle': row.spentPct <= 75,
                'bg-warning-subtle': row.spentPct > 75 && row.spentPct <= 100,
                'bg-danger-subtle': row.spentPct > 100,
              }"
              :style="{ width: `${Math.min(row.spentPct, 100)}%` }"
            />
            <span class="small spent-chip-text spent-chip-text--compact">
              ${{ row.spent.toFixed(2) }} / ${{ row.budget.toFixed(2) }}
            </span>
          </div>

          <button
            v-b-tooltip.click
            type="button"
            class="icon-btn p-0 border-0 bg-transparent text-muted"
            :title="`Remaining: $${row.remaining.toFixed(
              2
            )}.\nSpent: ${row.spentPct.toFixed(1)}%`"
            aria-label="View budget category details"
          >
            <IconInfoCircle :size="14" />
          </button>
        </div>
      </div>
      <!-- <div
        class="progress mt-1 mb-1"
        role="progressbar"
        :aria-valuenow="row.spentPct"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          class="progress-bar"
          :class="{
            'bg-success': row.spentPct <= 75,
            'bg-warning': row.spentPct > 75 && row.spentPct <= 100,
            'bg-danger': row.spentPct > 100,
          }"
          :style="{ width: `${Math.min(row.spentPct, 100)}%` }"
        />
      </div>
      <div class="d-flex justify-content-between small text-muted mb-1">
        <span>Remaining: ${{ row.remaining.toFixed(2) }}</span>
        <span>Spent: {{ row.spentPct.toFixed(1) }}%</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { vBTooltip } from "bootstrap-vue-next";
import { IconInfoCircle } from "@tabler/icons-vue";

export default {
  name: "BudgetOverview",
  components: {
    IconInfoCircle,
  },
  directives: {
    BTooltip: vBTooltip,
  },
  props: {
    selectedSnapshot: {
      type: Object,
      default: null,
    },
    overviewRows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.overview-panel {
  background: #fff;
}

.spent-chip {
  min-width: 11rem;
  height: 1.4rem;
  background: #f8f9fa;
}

.spent-chip-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.spent-chip-text {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  white-space: nowrap;
  color: #212529;
}

.spent-chip-text--compact {
  font-size: 0.75rem;
}

.icon-btn {
  line-height: 1;
}
</style>
